import React from 'react';
import ModalWindow from "../ModalWindow/ModalWindow";
import InfoManager from "../../managers/InfoManager";
import Localization from "../../localization";


export default class Settings extends React.Component {

    static instance;

    state = {
        isModalOpened: false
    };

    openModal = () => {
        this.setState({
            isModalOpened: true
        })
    };

    closeModal = () => {
        this.setState({
            isModalOpened: false
        })
    };

    componentDidMount() {
        Settings.instance = this;
    }

    render() {
        const {setLanguage, languageList} = this.props;

        if (!this.state.isModalOpened) return null;

        return (
            <ModalWindow close={this.closeModal}>
                <div className="modalContainer centered">
                    <h2>
                        {Localization.stringFor("chooseLanguage")}
                    </h2>
                    <br/>

                    <div key={'all_lang'}
                         className="langItem"
                         onClick={() => {setLanguage(false); this.closeModal();}}>

                        <img src={`./res/flags/globe.png`} alt=""/>

                        {Localization.stringFor("allLanguages")}

                    </div>

                    {
                        languageList.map(language => {
                            return (
                                <div key={language}
                                     className="langItem"
                                     onClick={() => {setLanguage(language); this.closeModal();}}>

                                    <img src={`./res/flags/${language}.svg`} alt=""/>

                                    {InfoManager.languageName(language)}
                                </div>
                            )
                        })
                    }
                </div>
            </ModalWindow>
        );
    }

}